<div class="container">
    <div class="title">{{title}}</div>
    <pre class="json-content">{{formattedJson}}</pre>
</div>
